<template>
  <div>
    <page-header
      title="Dynamic Numbering System"
      breadcrumb="Dashboard > Settings > Dynamic Numbering System"
    />
    <dns-data-table />
  </div>
</template>

<script>
import DnsDataTable from "@/components/3pl/Settings/DNS/DNSDataTable";
import PageHeader from "@/components/UI/NewPageHeader";
export default {
  components: {
    DnsDataTable,
    PageHeader
  },
};
</script>

<style></style>
